import moment from 'moment';

const DEBT_SUMMARY_CODES = new Set(['AR-001', 'AP-001']);

export const withDebtSummaryDefaultPeriod = (reportCode, filters = {}, currentDate = moment()) => {
  if (!DEBT_SUMMARY_CODES.has(reportCode) || filters.accounting_date_from || filters.accounting_date_to) return filters;
  return {
    ...filters,
    accounting_date_from: moment(currentDate).startOf('month').format('YYYY-MM-DD'),
    accounting_date_to: moment(currentDate).endOf('month').format('YYYY-MM-DD'),
  };
};

const splitAccountingBalance = (reportCode, value) => {
  if (value === null || value === undefined || value === '') return { debit: null, credit: null };
  const balance = Number(value);
  if (!Number.isFinite(balance)) return { debit: null, credit: null };
  const accountingBalance = reportCode === 'AP-001' ? -balance : balance;
  return {
    debit: Math.max(accountingBalance, 0),
    credit: Math.max(-accountingBalance, 0),
  };
};

export const mapDebtSummaryRows = (reportCode, rows = []) => {
  if (!DEBT_SUMMARY_CODES.has(reportCode)) return rows;
  return rows.map((row) => {
    const opening = splitAccountingBalance(reportCode, row.OPENINGBALANCE);
    const closing = splitAccountingBalance(reportCode, row.CLOSINGBALANCE);
    return {
      ...row,
      OPENINGDEBIT: opening.debit,
      OPENINGCREDIT: opening.credit,
      CLOSINGDEBIT: closing.debit,
      CLOSINGCREDIT: closing.credit,
    };
  });
};

export const getDebtSummaryItems = (reportCode, summary = {}) => {
  const isPayable = reportCode === 'AP-001';
  return [
    ['Dư Nợ đầu kỳ', isPayable ? summary.OPENINGCREDITBALANCE : summary.OPENINGDEBITBALANCE],
    ['Dư Có đầu kỳ', isPayable ? summary.OPENINGDEBITBALANCE : summary.OPENINGCREDITBALANCE],
    ['Tăng trong kỳ', summary.INCREASEAMOUNT],
    ['Giảm trong kỳ', summary.DECREASEAMOUNT],
    ['Dư Nợ cuối kỳ', isPayable ? summary.CLOSINGCREDITBALANCE : summary.CLOSINGDEBITBALANCE],
    ['Dư Có cuối kỳ', isPayable ? summary.CLOSINGDEBITBALANCE : summary.CLOSINGCREDITBALANCE],
    ['Số đối tượng', summary.TOTALITEMS, false],
    ['Số chứng từ', summary.DOCUMENTCOUNT, false],
  ];
};
